import Layout from "../views/layout/Layout";

export default {
    path: '',
    component: Layout,
    redirect: '/summary',
    meta: {title: '数据分析', icon: 'el-icon-data-line'},
    children: [{
        path: 'summary',
        name: 'summary',
        component: () => import('@/views/datas/summary/index'),
        meta: {title: '汇总数据', icon: 'product-cate'},
        auth: 'datas:summary'
    }, {
        path: 'ranking',
        name: 'ranking',
        component: () => import('@/views/datas/ranking/index'),
        meta: {title: 'TOP排行榜', icon: 'product-cate'},
        auth: 'datas:ranking'
    }, {
        path: 'docForm',
        name: 'docForm',
        component: () => import('@/views/datas/docForm/index'),
        meta: {title: '网点报表', icon: 'product-cate'},
        auth: 'datas:docForm'
    }, {
        path: 'agentForm',
        name: 'agentForm',
        component: () => import('@/views/datas/agentForm/index'),
        meta: {title: '代理商报表', icon: 'product-cate'},
        auth: 'datas:agentForm'
    }, {
        path: 'countData',
        name: 'countData',
        component: () => import('@/views/datas/countData/index'),
        meta: {title: '计费数据分析', icon: 'product-cate', insideURL: true},
        auth: 'datas:countData',
        redirect: '/countData/powerBank',
        children: [{
            path: 'powerBank',
            name: 'powerBank',
            component: () => import('@/views/datas/countData/powerBank'),
            meta: {title: '充电宝', icon: 'product-cate'},
        }, {
            path: 'charger',
            name: 'charger',
            component: () => import('@/views/datas/countData/charger'),
            meta: {title: '充电线', icon: 'product-cate'},
        }]
    }, {
        path: 'operateOffice',
        name: 'operateOffice',
        component: () => import('@/views/datas/operateOffice/index'),
        meta: {title: '运营代办', icon: 'product-cate'},
        auth: 'datas:operateOffice'
    }, {
        path: 'financeOffice',
        name: 'financeOffice',
        component: () => import('@/views/datas/financeOffice/index'),
        meta: {title: '财务代办', icon: 'product-cate'},
        auth: 'datas:financeOffice'
    }, {
        path: 'platformDailyReport',
        name: 'platformDailyReport',
        component: () => import('@/views/datas/platformDailyReport/index'),
        meta: {title: '平台运营日报表', icon: 'product-cate'},
        auth: 'datas:platformDailyReport'
    },{
        path: 'financeForm',
        name: 'financeForm',
        component: () => import('@/views/datas/financeForm/index'),
        meta: {title: '平台财务报表', icon: 'product-cate'},
        auth: 'datas:financeForm'
    },{
        path: 'distributionProportion',
        name: 'distributionProportion',
        component: () => import('@/views/datas/distributionProportion/index'),
        meta: {title: '平台营运分布占比', icon: 'product-cate'},
        auth: 'datas:distributionProportion'
    },{
        path: 'distributionProportionMore',
        name: 'distributionProportionMore',
        component: () => import('@/views/datas/distributionProportionMore/index'),
        meta: {title: '平台营运分布占比 / 查看更多', icon: 'product-cate'},
        auth: 'datas:distributionProportionMore',
        hidden: true
    },{
        path: 'orderTrendAnalysis',
        name: 'orderTrendAnalysis',
        component: () => import('@/views/datas/orderTrendAnalysis/index'),
        meta: {title: '平台订单趋势分析', icon: 'product-cate'},
        auth: 'datas:orderTrendAnalysis'
    },{
        path: 'yesterdayData',
        name: 'yesterdayData',
        component: () => import('@/views/datas/yesterdayData/index'),
        meta: {title: '昨日营运数据', icon: 'product-cate'},
        auth: 'datas:yesterdayData'
    },{
        path: 'equipmentAnalysis',
        name: 'equipmentAnalysis',
        component: () => import('@/views/datas/equipmentAnalysis/index'),
        meta: {title: '平台设备趋势分析', icon: 'product-cate'},
        auth: 'datas:equipmentAnalysis',
    },{
        path: 'profit',
        name: 'profit',
        component: () => import('@/views/datas/profit/index'),
        meta: {title: '数据订单报表', icon: 'product-cate'},
        auth: 'datas:profit'
    }]
}



// WEBPACK FOOTER //
// ./src/router/datas.js